module.exports = __webpack_public_path__ + "images/sam/split-button-arrow.png";